import type { EHRProvider } from '@heidi/schema/ml-scribe';
import { atom } from 'jotai';
import { atomFamily, atomWithStorage, createJSONStorage } from 'jotai/utils';

export const epicLaunchSessionIdAtom = atom<string>('');

// Per-EHR-provider "re-pair required" flag (ANZ-1193), keyed so one provider's
// 409 cannot flip an unrelated surface. Set from the EHR appointments query
// outcome (409 -> true, success -> false); drives the integrations reconnect
// banner and suppresses focus/reconnect refetches while broken.
export const ehrRePairRequiredAtomFamily = atomFamily((provider: string) => {
  void provider; // keyed by provider; each provider gets its own boolean atom
  return atom<boolean>(false);
});

const booleanSessionStorage = createJSONStorage<boolean>(() => sessionStorage);

/**
 * Tracks whether the user has completed onboarding during the widget auth flow.
 * This persists through route changes via sessionStorage to ensure onboarding
 * completes before the widget auth flow shows its own modals.
 */
export const hasCompletedOnboardingForWidgetAtom = atomWithStorage<boolean>(
  'hasCompletedOnboardingForWidget',
  false,
  booleanSessionStorage
);

export const selectedIntegrationAtom = atom<EHRProvider>();
export const integrationMaxAttemptsReachedAtom = atom<boolean>(false);
